<script module lang="ts">
  import { browser } from '$app/environment';

  const SCROLL_PERSISTENCE: Record<string, number> = $state({});

  let popstate = $state(false);

  const onPopstate = (): void => {
    popstate = true;
  };

  if (browser) {
    window.addEventListener('popstate', onPopstate);
  }
</script>

<script lang="ts">
  import PullToRefresh from '$components/PullToRefresh.svelte';
  import { afterNavigate } from '$app/navigation';
  import { stateIsOnline } from '$states/stateIsOnline.svelte';
  import { page } from '$app/state';

  let height = $state(0);

  interface Props {
    withoutScroll?: boolean;
    withPullToRefresh?: boolean;
    pullToRefreshVerticalOffset?: number;
    pullToRefreshAction?: (() => void) | undefined;
    top?: import('svelte').Snippet;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    middle?: import('svelte').Snippet<[any]>;
    bottom?: import('svelte').Snippet;
  }

  let {
    withoutScroll = false,
    withPullToRefresh = false,
    pullToRefreshVerticalOffset = 0,
    pullToRefreshAction = undefined,
    top,
    middle,
    bottom,
  }: Props = $props();

  let middleContainer = $state<HTMLDivElement | null>(null);
  let middleContainerContent = $state<HTMLDivElement | null>(null);

  let scrollTop = $state(0);

  const onScroll = (e: Event) => {
    scrollTop = (e.target as HTMLDivElement).scrollTop;
    SCROLL_PERSISTENCE[location.pathname] = scrollTop;
  };

  afterNavigate(() => {
    if (middleContainer) {
      middleContainer.scrollTop = popstate ? (SCROLL_PERSISTENCE[location.pathname] ?? 0) : 0;
    }

    if (middleContainer?.scrollTop === 0) {
      SCROLL_PERSISTENCE[location.pathname] = 0;
    }

    popstate = false;
  });

  let overflow = $derived(withoutScroll ? 'overflow-hidden' : 'overflow-y-auto');

  let cssViewTransitionClass = $derived.by(() => {
    if (page.url.pathname.startsWith('/0x')) {
      /**
       * Profile pages are handled uniquely
       */
      return '';
    }
    if (
      ['/card', '/circles', '/circles/onboard', '/wallet', '/gnosis-pay'].includes(
        page.url.pathname,
      )
    ) {
      return 'DASHBOARD_COMPONENT';
    }
    return 'PAGE_COMPONENT';
  });
</script>

<div
  class="{cssViewTransitionClass} mx-auto grid h-screen w-full grid-rows-[auto_1fr_auto] bg-background">
  <div class="PAGE_COMPONENT_TOP">
    {@render top?.()}
  </div>
  <div
    class="relative h-full {overflow}"
    bind:clientHeight={height}
    bind:this={middleContainer}
    onscroll={onScroll}>
    {#if withPullToRefresh && middleContainerContent && stateIsOnline.current}
      <PullToRefresh
        {scrollTop}
        element={middleContainer}
        elementToMove={middleContainerContent}
        {pullToRefreshAction}
        {pullToRefreshVerticalOffset} />
    {/if}
    <div bind:this={middleContainerContent} class="h-full">
      {@render middle?.({ height })}
    </div>
  </div>
  <div class="h-max">
    <div class:pb-safe={bottom}>
      {@render bottom?.()}
    </div>
  </div>
</div>
